import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { removerAcentos } from '../../../../../utils'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../Components/CustomUi/loading'

interface PropsTabela {
  listar_microrganismo: any[]
  carregando_microrganismo: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  excluir: Function
  confirmar_exclusao: boolean
  buscarTabela: string
  abrir: Function
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  editar: React.Dispatch<React.SetStateAction<number>>
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  filtroAtivado?: boolean
  setFiltroAtivado?: React.Dispatch<React.SetStateAction<boolean>>
  totalRef: number
}

export const TabelaMicrorganismos: React.FC<PropsTabela> = ({
  listar_microrganismo,
  carregando_microrganismo,
  setPagination,
  page,
  setPage,
  total,
  excluir,
  confirmar_exclusao,
  fake_loading,
  id_item_atual,
  nome_item_atual,
  buscarTabela,
  setBuscarTabela,
  editar,
  setConfirmar_exclusao,
  setFake_loading,
  setId_item_atual,
  setNome_item_atual,
  abrir,
  filtroAtivado,
  setFiltroAtivado,
  totalRef,
}) => {
  function buscarMicrorganismos(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome_cientifico))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <>
      <Inline alignItems='center'>
        <Input
          placeholder='Buscar microrganismos'
          value={buscarTabela}
          onChange={setBuscarTabela}
        />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { id: 1, valor: 'Nome cientifico', width: 'calc(100% - 577px)' },
          { id: 2, valor: 'Tipo', width: '400px' },
          { id: 5, valor: 'Ações', width: '170px' },
        ]}
      />

      <BodyTable
        paginate={totalRef}
        onChangeItensPage={setPagination}
        paginateFilter={
          filtroAtivado
            ? (listar_microrganismo ?? []).filter(buscarMicrorganismos(buscarTabela)).length
            : 0
        }
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          marginTop: -10,
          height: listar_microrganismo?.length < 8 ? '100%' : 'calc(100vh - 280px)',
          position: 'relative',
          overflowX: 'hidden',
        }}
      >
        <Render condition={carregando_microrganismo === false}>
          {(listar_microrganismo ?? []).filter(buscarMicrorganismos(buscarTabela)).map((item) => {
            return (
              <RowTable key={item?.cod} onDoubleClick={undefined}>
                <RowItem width={'calc(100% - 575px)'} fontSize={13}>
                  {item?.nome_cientifico}
                </RowItem>
                <RowItem width={'400px'} fontSize={13}>
                  {item?.tipo_microrganismo_nome}
                </RowItem>
                <RowItem width={'170px'} gap={10}>
                  <DeleteButton
                    open={confirmar_exclusao && id_item_atual === item?.cod}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(item?.cod)
                      setNome_item_atual(item?.nome_cientifico)
                    }}
                    loading={fake_loading}
                    message={`o item ${item?.nome_cientifico} será excluido!`}
                    deleteds={[item?.nome_cientifico]}
                    onDelete={() => {
                      excluir(item?.cod)
                    }}
                    disabled={fake_loading}
                  />
                  <ButtonCustom
                    onClick={() => editar(item?.cod)}
                    icon={<FontAwesomeIcon icon={faEdit} />}
                  >
                    Editar
                  </ButtonCustom>
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={carregando_microrganismo}>
          <Carregando
            animation
            justifyContent='center'
            legenda='Buscando microrganismos...'
            size={'default'}
            height={350}
          />
        </Render>
      </BodyTable>
    </>
  )
}
